module.exports = __webpack_public_path__ + "static/media/service-web-development.cf1357a1.png";